/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Sage_Stork_LeadInputs */

const en_lean_sage_stork_lead = /** @type {(inputs: Lean_Sage_Stork_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content shared`)
};

const de_lean_sage_stork_lead = /** @type {(inputs: Lean_Sage_Stork_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt geteilt`)
};

/**
* | output |
* | --- |
* | "Content shared" |
*
* @param {Lean_Sage_Stork_LeadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_sage_stork_lead = /** @type {((inputs?: Lean_Sage_Stork_LeadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Sage_Stork_LeadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_sage_stork_lead(inputs)
	return de_lean_sage_stork_lead(inputs)
});